import React, { useContext, useEffect, useRef, useState } from 'react'
import Loader from '../../../Base/Components/Loader/Loader';
import { getGenerarExcelVentas, getVentasAnualPorAgente, getVentasMesAgenteAgrupadas, getVentasPresMenCategCliente, getVentasPresMenSecciones, getVentasSegunSeccionesAgente, VentasPresMenAgente, VentasPresMenAgentsName } from '../../../API/Ventas/ResumenVentasRequest';
import { Toast } from 'primereact/toast';
import { toastShow } from '../../../Base/Services/ToastService';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { setHeightAgGrid, setHeightAgGridWithHeight } from '../../../Base/Components/Tables/AgGrid/AgGridUtils';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { resumenVentasLang } from './ResumenVentasLang';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import { getDateTextSmall } from '../../../Base/Services/Moment/Luxon';
import { getCalendarioOperativoMensual } from '../../../Base/API/Global/CalendarioOperativo/CalendarioOperativoRequest';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import DialogChartAgentes from './DialogChartAgentes';
import ResumenVentasDialog from './ResumenVentasDialog';
import { baseLang } from '../../../Base/Lang/BaseLang';
import * as XLSX from 'xlsx-js-style';
import { getLocalDateString1 } from '../../../Base/Services/FechasService';
import { descargarArchivo } from '../../../Base/Services/ArchivosService';
import { Height } from '@mui/icons-material';
import ResumenVentasAnual from './ResumenVentasAnual';

import ResumenVentasAnualbyCliente from './ResumenVentasAnualbyCliente';

const DialogTablesVentasMensual = ({ date }) => {
    const toast = useRef(null);

    const [loading, setloading] = useState();
    const [ventasCotton, setVentasCotton] = useState([]);
    const [ventasPoly, setVentasPoly] = useState([]);
    const [resumenVentas, setResumenVentas] = useState([]);
    const [resumenServiCliente, setResumenServiCliente] = useState([]);
    const [resumenVentasAgentes, setResumenVentasAgentes] = useState({})
    const [secciones, setSecciones] = useState([]);
    const [ventasSegunAgente, setVentasSegunAgente] = useState({});
    const [seccionesSegunAgente, setSeccionesSegunAgente] = useState([]);
    const [resumenSegunAgente, setResumenSegunAgente] = useState([])
    const [granTotal, setgranTotal] = useState([]);
    const [granTotalAnual, setGranTotalAnual] = useState({})
    const [totalSegunAgente, setTotalSegunAgente] = useState([])
    const [mes, setMes] = useState(null);
    const [grandTotal, setGrandTotal] = useState([]);
    const [showDialogAgent, setShowDialogAgent] = useState(false);
    const [showDialog, setShowDialog] = useState(false);

    const [ventasAnualPorAgente, setventasAnualPorAgente] = useState([])

    const { config } = useContext(ConfigContext);

    const rowClassRules = {
        'ag-rows-bold': (params) => (params?.data?.CustomerName?.length > 0 && params?.data?.CustomerName !== 'GRAND TOTAL') ? false : true,
        'ag-rows-medium': (params) => (params?.data?.CustomerName?.length > 0) ? false : true,
        'ag-rows-large': (params) => (params?.data?.CustomerName === 'GRAND TOTAL'),
    }


    const getInfo = async () => {
        setloading(true);
        let t = await getVentasPresMenCategCliente({ Anio: date.getFullYear(), Mes: date.getMonth() + 1 });

        // t = t.map((item) => {return { ...item, Porcent: (item.Ventas * 100) / item.Presupuesto } })

        let ventasAnualAgente = await getVentasAnualPorAgente({ Anio: date.getFullYear() });

        setGranTotalAnual({
            IdAgent: 0,
            Agente: 'GRAND TOTAL',
            AmountT: ventasAnualAgente.reduce((a, b) => a + b.TotalAmount, 0),
            Porcent: 100,
        })

        // asignar el porcentaje total anual a cada agente
        ventasAnualAgente = ventasAnualAgente.map((item) => {
            return {
                ...item,
                Porcent: (item.TotalAmount * 100) / ventasAnualAgente.reduce((a, b) => a + b.TotalAmount, 0)
            }
        })
        // ventasAnualAgente.push(granTotalAnual);
        setventasAnualPorAgente(ventasAnualAgente);
        console.log({ ventasAnualPorAgente: ventasAnualAgente });

        const m = await getCalendarioOperativoMensual()
        let mt = m.filter((item) => item.Mes === date.getMonth() + 1 && item.Ano === date.getFullYear());
        const a = await VentasPresMenAgente({ Anio: date.getFullYear(), Mes: date.getMonth() + 1 });
        console.log({a});
        const agentes = await VentasPresMenAgentsName({ Anio: date.getFullYear(), Mes: date.getMonth() + 1 });
        const tempoSecciones = await getVentasPresMenSecciones({ Anio: date.getFullYear(), Mes: date.getMonth() + 1 })
        const tempoVentasSegunAgente = await getVentasSegunSeccionesAgente({ Anio: date.getFullYear(), Mes: date.getMonth() + 1 });
        if (tempoVentasSegunAgente?.length > 0) {
            let valoresVentasAgente = {}
            let valSegunAgentes = []

            let totalSegunAgentes = {
                IdAgent: 0,
                Agente: 'GRAND TOTAL',
                AmountT: tempoVentasSegunAgente?.reduce((a, b) => a + b.AmountT, 0)

            }
            let temSecciones = tempoVentasSegunAgente.map((t) => {
                return {
                    Seccion: t.Seccion
                }
            });
            if (temSecciones.length > 0) {
                temSecciones?.sort((a, b) => a > b ? 1 : -1)

                const ContedorAgentes = document.getElementById("ContenerdorAgentes");
                let alturaContedorAgentes = ((ContedorAgentes.offsetHeight / window.innerHeight) * 100) - 1
                let cantidadFilas = a.length
                let alturaMin = 18
                let alturaMax = 95
                temSecciones.forEach((s, index) => {

                    let AgentesSeccion = tempoVentasSegunAgente.filter((a) => a.Seccion === s.Seccion)
                    let totalAgenteSeccion = []
                    if (AgentesSeccion.length > 0) {
                        let valoresTempo = []
                        AgentesSeccion.forEach((item) => {
                            let totalAgente = {
                                IdAgent: item.IdAgent,
                                Agente: item.AgenteVentas,
                                AmountT: tempoVentasSegunAgente.filter((i) => i.IdAgent === item.IdAgent).reduce((a, b) => a + b.AmountT, 0),
                                // noSumary: true,
                            }
                            valoresTempo.push(...tempoVentasSegunAgente.filter((i) => i.IdAgent === item.IdAgent));
                            // valoresTempo.push(totalAgente);
                            totalAgenteSeccion.push(totalAgente)

                        })
                        let totalSeccion = {}
                        if (valoresTempo?.length > 0) {
                            let nombreSeccion = s?.Seccion?.charAt(0).toUpperCase() + s?.Seccion?.slice(1).toLowerCase();
                            totalSeccion = {
                                IdAgent: 0,
                                // Agente: nombreSeccion,
                                TotalSeccion: true,
                                CustomerName: 'Total ' + nombreSeccion,
                                AmountT: totalAgenteSeccion?.reduce((t, v) => t + v.AmountT, 0),
                                // noSumary: true,
                            }

                        }
                        let altura = (valoresTempo.length - totalAgenteSeccion.length) / cantidadFilas * alturaMax
                        if (altura < alturaMin) {
                            altura = alturaMin
                            alturaMax = alturaMax - alturaMin
                        }
                        valoresVentasAgente[s.Seccion] = {
                            DataAgente: valoresTempo,
                            TotalSeccion: [totalSeccion],
                            Altura: altura,
                            // Height: `3.5vh`,
                            Height: `${alturaContedorAgentes / tempoSecciones.length + 1}vh`
                        }
                        alturaMax = alturaMax - 2

                        valSegunAgentes.push(...valoresTempo);
                        valSegunAgentes.push(totalSeccion);
                    }


                })
                valoresVentasAgente['GRAND TOTAL'] = {
                    DataAgente: [totalSegunAgentes],
                    TotalSeccion: [],
                    Height: '8vh',
                }

                setSeccionesSegunAgente(temSecciones)
                setResumenSegunAgente(valSegunAgentes)
                setVentasSegunAgente(valoresVentasAgente)
                setTotalSegunAgente(valoresVentasAgente)
            }


        }


        setSecciones(tempoSecciones.sort((a, b) => a > b ? 1 : -1))

        let valAgentes = []
        // let secciones = [...new Set(agentes.map(item => item.Seccion))]

        let granTotal = a.reduce((a, b) => a + b.AmountT, 0);
        let Kgs = a.reduce((a, b) => a + b.Kgs, 0);
        let granTotalAgentes = {
            IdAgent: 0,
            Agente: 'GRAND TOTAL',
            AmountT: granTotal,
            Porcent: 100,
            Kgs: Kgs
        };
        let valoresFinales = {}
        if (agentes.length > 0) {
            if (tempoSecciones?.length > 0) {
                // let cantidadSeccion = tempoSecciones.length
                const ContedorAgentes = document.getElementById("ContenerdorAgentes");
                let alturaContedorAgentes = ((ContedorAgentes.offsetHeight / window.innerHeight) * 100) - 1
                // let cantidadRestante = 85
                let cantidadFilas = a.length
                let alturaMin = 18
                let alturaMax = 95
                tempoSecciones.forEach((s, index) => {

                    let AgentesSeccion = agentes.filter((a) => a.Seccion === s.Seccion)
                    let totalAgenteSeccion = []
                    if (AgentesSeccion.length > 0) {
                        let valoresTempo = []
                        AgentesSeccion.forEach((item) => {
                            let total = a.filter((i) => i.IdAgent === item.IdAgent).reduce((a, b) => a + b.AmountT, 0)
                            let Kgs = a.filter((i) => i.IdAgent === item.IdAgent).reduce((a, b) => a + b.Kgs, 0)
                            let totalAgente = {
                                IdAgent: item.IdAgent,
                                Agente: item.AgenteVentas,
                                AmountT: total,
                                Porcent: (total * 100) / granTotal,
                                Kgs: Kgs,
                                noSumary: true,
                            }
                            let row = a.filter((i) => i.IdAgent === item.IdAgent).map((i) => { return { ...i, Porcent: (i.AmountT * 100) / granTotal } })

                            // valoresTempo.push(...a.filter((i) => i.IdAgent === item.IdAgent));
                            valoresTempo.push(...row);
                            valoresTempo.push(totalAgente);
                            totalAgenteSeccion.push(totalAgente)
                        })
                        let totalSeccion = {}
                        if (valoresTempo?.length > 0) {
                            let nombreSeccion = s?.Seccion?.charAt(0).toUpperCase() + s?.Seccion?.slice(1).toLowerCase();
                            let total = totalAgenteSeccion?.reduce((t, v) => t + v.AmountT, 0)
                            let totalKgs = totalAgenteSeccion?.reduce((t, v) => t + v.Kgs, 0)
                            totalSeccion = {
                                IdAgent: 0,
                                // Agente: nombreSeccion,
                                TotalSeccion: true,
                                CustomerName: 'Total ' + nombreSeccion,
                                Kgs: totalKgs,
                                AmountT: total,
                                Porcent: (total * 100) / granTotal,
                                noSumary: true,
                            }
                        }


                        let altura = (valoresTempo.length - totalAgenteSeccion.length) / cantidadFilas * alturaMax
                        if (altura < alturaMin) {
                            altura = alturaMin
                            alturaMax = alturaMax - alturaMin
                        }
                        valoresFinales[s.Seccion] = {
                            DataAgente: valoresTempo,
                            TotalSeccion: [totalSeccion],
                            Altura: altura,
                            Porcent: valoresTempo / 100,
                            // Height: `3.5vh`,
                            Height: `${alturaContedorAgentes / tempoSecciones.length + 1}vh`
                        }
                        alturaMax = alturaMax - 2

                        valAgentes.push(...valoresTempo);
                        valAgentes.push(totalSeccion);
                    }


                })
                valoresFinales['GRAND TOTAL'] = {
                    DataAgente: [granTotalAgentes],
                    TotalSeccion: [],
                    Height: '8vh',
                }

            }
        }
        setResumenVentasAgentes(valoresFinales)
        setGrandTotal([granTotalAgentes]);
        setResumenVentas(valAgentes);
        if (mt.length > 0) {
            setMes(mt[0]);
        }

        if (t.length > 0) {
            let cotton = t.filter((item) => item.IdCategoria === 1)
            let poly = t.filter((item) => item.IdCategoria === 2);

            setVentasCotton(cotton);
            setVentasPoly(poly);
            let presupuesto = t.reduce((a, b) => a + b.Presupuesto, 0)
            let ventas = t.reduce((a, b) => a + b.Ventas, 0)
            let KgsPresupuesto = t.reduce((a, b) => a + b.KgsPresupuesto, 0)
            let KgsVentas = t.reduce((a, b) => a + b.KgsVentas, 0)
            let total = [
                {
                    CustomerName: 'GRAND TOTAL',
                    Presupuesto: presupuesto,
                    Ventas: ventas,
                    KgsPresupuesto: KgsPresupuesto,
                    KgsVentas: KgsVentas,
                    Porcent: ventas / presupuesto * 100,
                }
            ]
            console.log({total});
            setgranTotal(total);

        } else {
            toastShow(toast, 'error', 'Error', 'No se encontraron datos');
        }
        setloading(false);

    }



    const columTotal = [
        {
            field: 'CustomerName',
            header: 'Cliente',
            headerEn: 'Customer',
            className: 'large',
            flex: 1,
        },
        {
            headerName: 'Budget',
            children: [
                {
                    field: 'KgsPresupuesto',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'Presupuesto',
                    header: 'Amount $',
                    headerEn: '',
                    className: 'small',
                    width: 150,
                    Format: 'Currency',
                    Sumary: 'sum',
                    prefix: '$'
                },
            ]
        },
        {
            headerName: 'Real',
            children: [
                {
                    field: 'KgsVentas',
                    header: 'Kgs',
                    headerEn: '',
                    className: 'small',
                    Format: 'Currency',
                    Sumary: 'sum',
                },
                {
                    field: 'Ventas',
                    header: 'Amount $',
                    headerEn: '',
                    className: 'small',
                    width: 150,
                    Format: 'Currency',
                    Sumary: 'sum',
                    prefix: '$'
                },

            ]
        },

        {
            field: 'PorcentajeCumplimiento',
            header: '% Cumplimineto',
            headerEn: '',
            className: 'Xsmall',
            Format: 'Porcentaje',
            calcFunction: (params) => {
                return params?.data?.Ventas / params?.data?.Presupuesto * 100
            }
            // Sumary: 'avg'
        },
    ]

    const tableTotalCotton = {
        Data: ventasCotton,
        Columns: [
            {
                headerName: 'Algodon',
                headerNameEn: 'Cotton',
                children: [
                    ...columTotal
                ]
            },
        ],
        hideFilter: true,
        rowClassRules: rowClassRules
    }

    const tableTotalPoly = {
        Data: ventasPoly,
        Columns: [
            {
                headerName: 'Sintetico',
                headerNameEn: 'Synthetic',
                children: [
                    ...columTotal
                ]
            }
        ],
        hideFilter: true,
        rowClassRules: rowClassRules
    }


    const tableGranTotal = {
        Data: granTotal,
        Columns: columTotal,
        hideFilter: true,
        hideFooter: true,
        rowClassRules: rowClassRules
    }

    const tableAgentes = {
        Data: resumenVentas,
        Columns: [
            {
               headerName: '',
               children: [
                
                   
                               {
                                   field: 'Agente',
                                   header: 'Agente',
                                   headerEn: 'Agent',
                                   className: 'medium',
                                   Sumary: 'GRAND TOTAL',
                               },
                               {
                                   field: 'CustomerName',
                                   header: 'Cliente',
                                   headerEn: 'Customer',
                                   className: 'Xlarge',
                                   flex: 1,
                               },
                               // {
                               //     field: 'Presupuesto',
                               //     header: 'Budget $',
                               //     headerEn: '',
                               //     className: 'small',
                               //     Format: 'Currency',
                               //     Sumary: 'sum',
                               // },
                               {
                                   field: 'Kgs',
                                   header: 'Kgs',
                                   headerEn: '',
                                   className: 'small',
                                   Format: 'Currency',
                                   Sumary: 'sum',
                               },
                               {
                                   field: 'AmountT',
                                   header: 'Monto $',
                                   headerEn: 'Amount $',
                                   className: 'medium',
                                   Format: 'Currency',
                                   Sumary: 'sum',
                                   prefix: '$'
                               },
                               {
                                   field: 'Porcent',
                                   header: '%',
                                   headerEn: '%',
                                   className: 'Xsmall',
                                   Format: 'Porcentaje',
                                   calcFunction: (params) => {
                                       return params?.data?.AmountT / grandTotal[0]?.AmountT * 100
                                   }
                               },
                ]
            },
        ],
        hideFilter: true,
        hideFooter: true,
        // pinnedBottomRowData: grandTotal,
        rowClassRules: {
            'ag-rows-bold': (params) => (params?.data?.Agente?.length > 0 || params?.data?.TotalSeccion),
            'ag-rows-medium': (params) => (params?.data?.Agente?.length > 0 || params?.data?.TotalSeccion),
            'ag-rows-large': (params) => (params?.data?.Agente === 'GRAND TOTAL'),
            'ag-rowsSeccionEnd': (params) => (params?.data?.Agente?.length > 0 || params?.data?.TotalSeccion),
            'ag-rowsBackground-gray': (params) => (params?.data?.TotalSeccion),
        }
    }

    const stylesTextBold = (params) => {
        return {
            'text-align': 'right',
            'font-weight': 'bold',
        }
    }

    const columnsVentasAnualPorAgente = [
        {
            field: 'AgenteVentas',
            header: 'Agente Ventas',
            headerEn: '',
            className: 'large',
            frozen: true,
            flex: 1,
            cellStyle: (params) => {
                return {
                    'text-align': 'left',
                    'font-weight': 'bold',
                }
            }
        },
        {
            field: 'Seccion',
            header: 'Seccion',
            headerEn: '',
            className: 'large',
            // flex: 1,
            // Sort: 'asc',
        },
        {
            field: 'Enero_Amount',
            header: 'Enero',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Febrero_Amount',
            header: 'Febrero',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Marzo_Amount',
            header: 'Marzo',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Abril_Amount',
            header: 'Abril',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Mayo_Amount',
            header: 'Mayo',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Junio_Amount',
            header: 'Junio',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Julio_Amount',
            header: 'Julio',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Agosto_Amount',
            header: 'Agosto',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Septiembre_Amount',
            header: 'Septiembre',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Octubre_Amount',
            header: 'Octubre',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Noviembre_Amount',
            header: 'Noviembre',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'Diciembre_Amount',
            header: 'Diciembre',
            headerEn: '',
            className: 'small',
            width: 100,
            Format: 'Currency',
            Sumary: 'sum',
            prefix: '$',
        },
        {
            field: 'TotalKgs',
            header: 'Total (Kgs)',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            Sumary: 'sum',
            frozen: true,
            alignFrozen: 'right',
            // suffix: ' kg',
            cellStyle: stylesTextBold
        },
        {
            field: 'TotalAmount',
            header: 'Total Amount ($)',
            Format: 'Currency',
            Sumary: 'sum',
            headerEn: '',
            className: 'small',
            frozen: true,
            alignFrozen: 'right',
            prefix: '$',
            cellStyle: stylesTextBold

        },
        {
            field: 'Porcent',
            header: '%',
            Format: 'Porcentaje',
            Sumary: 'sum',
            headerEn: '',
            className: 'Xsmall',
            sort: 'desc',
            frozen: true,
            alignFrozen: 'right',
            cellStyle: stylesTextBold
        },
    ]

    const rowClassRulesTotal = {
        'ag-rows-bold': (params) => (params?.data?.AgenteVentas ? false : true),
    }

    const tableVentasAnualPorAgente = {
        Columns: columnsVentasAnualPorAgente,
        Data: ventasAnualPorAgente,
        rowClassRules: rowClassRulesTotal,
    }


    const GenerarExcel = async () => {
        setloading(true)
        const tempoArchivos = await getGenerarExcelVentas({ Mes: mes?.Mes, Anio: mes?.Ano })
        if (tempoArchivos) {
            if (tempoArchivos?.creado) {
                let dataArchivo = tempoArchivos?.Archivo
                if (dataArchivo) {
                    let filename = "Resumen Ventas- " + getLocalDateString1(new Date())
                    const downloadLink = document.createElement('a');
                    const fileName = filename;
                    descargarArchivo(dataArchivo, downloadLink, fileName)
                }
            }
        }
        setloading(false)
    }



    console.log({ granTotal });
    useEffect(() => {
        if (date) {
            getInfo()
        }

    }, [date])

    return (
        <div id='DialogTablesVentasMensual' style={{ width: '99%', justifyContent: 'space-around' }}>
            {/* DialogTablesVentasMensual */}
            <Loader loading={loading} querySelector={'#DialogTablesVentasMensual'} />
            <Toast ref={toast} />
            <div className='d-flex gap' style={{ justifyContent: 'space-around' }}>
                <div style={{ height: '90vh', width: '53%' }} >
                    <div style={{ textAlign: 'center' }}>
                        <div className="d-flex justify-content-center align-items-center text-center">
                            <h4>{getLabel(resumenVentasLang, 'TituloCliente', config.language)}</h4>
                            <Button
                                className="p-button-text"
                                style={{ zIndex: 1000 }}
                                tooltip={getLabel(baseLang, "ventasCliente", config.language)}
                                icon='pi pi-chart-bar'
                                onClick={e => setShowDialog(true)}
                            />
                            <Button
                                icon='ri-file-excel-2-fill' text loading={loading}
                                onClick={() => GenerarExcel()}
                            />
                            <Button icon='pi pi-refresh' onClick={() => getInfo()} text loading={loading} />
                        </div>
                        {/* MES Y ANIO */}
                        {mes && <h5>
                            {config.language === 'es' ? mes?.NombreMesEs : mes?.NombreMesEn}  {mes?.Ano}   ({getDateTextSmall(mes?.FechaInicio)} - {getDateTextSmall(mes?.FechaFinal)})
                        </h5>}
                    </div>
                    <div style={{ height: 'calc((90vh - 130px) / 2)' }}>
                        {/* <div style={{ height: setHeightAgGrid(tableTotalCotton, 10) }}> */}
                        {/* <div style={{ height: setHeightAgGrid(tableTotalCotton, ventasCotton?.length) }}> */}
                        <AgGrid table={tableTotalCotton} height={'300px'} />
                    </div>
                    {/* <div style={{ height: setHeightAgGrid(tableTotalPoly, 10) }}> */}
                    <div style={{ height: 'calc((90vh - 130px) / 2)' }}>
                        {/* <div style={{ height: setHeightAgGrid(tableTotalPoly, ventasPoly?.length) }}> */}
                        <AgGrid table={tableTotalPoly} height={'300px'} />
                    </div>
                    <div style={{ height: setHeightAgGrid(tableGranTotal, 2) }}>
                        <AgGrid table={tableGranTotal} />
                    </div>
                </div>
                <div style={{ height: '100%', width: '47%' }} id='ContenerdorAgentes'>
                    <div style={{ textAlign: 'center' }}>
                        <div className="d-flex justify-content-center align-items-center text-center">
                            <h4>{getLabel(resumenVentasLang, 'TituloAgente', config.language)}</h4>
                            <Button
                                className="p-button-text"
                                style={{ zIndex: 1000 }}
                                tooltip={getLabel(baseLang, "ventasCliente", config.language)}
                                icon='pi pi-chart-pie'
                                onClick={e => setShowDialogAgent(true)}
                            />
                        </div>
                        {/* MES Y ANIO */}
                        {mes && <h5>
                            {config.language === 'es' ? mes?.NombreMesEs : mes?.NombreMesEn}  {mes?.Ano}   ({getDateTextSmall(mes?.FechaInicio)} - {getDateTextSmall(mes?.FechaFinal)})
                        </h5>}
                    </div>
                    <div style={{ height: 'calc(90vh - 130px)', }}>
                        <div style={{ height: '100%' }}>
                            <AgGrid table={{ ...tableAgentes, Data: resumenVentas }} />
                        </div>

                    </div>
                    <div style={{ height: setHeightAgGrid(tableAgentes, 2) }}>
                        <AgGrid table={{
                            ...tableAgentes, Data: resumenVentasAgentes['GRAND TOTAL']?.DataAgente ?? [], hideFooter: true,
                        }} />
                    </div>

                </div>
                <div style={{ height: '100%', width: '35%', display: 'none' }}>
                    <div style={{ textAlign: 'center' }}>
                        <div className="d-flex justify-content-center align-items-center text-center">
                            <h4>{getLabel(resumenVentasLang, 'TituloSegunAgente', config.language)}</h4>
                            <Button
                                className="p-button-text"
                                style={{ zIndex: 1000 }}
                                tooltip={getLabel(baseLang, "ventasCliente", config.language)}
                                icon='pi pi-chart-pie'
                                onClick={e => setShowDialogAgent(true)}
                            />
                        </div>
                        {/* MES Y ANIO */}
                        {mes && <h5>
                            {config.language === 'es' ? mes?.NombreMesEs : mes?.NombreMesEn}  {mes?.Ano}   ({getDateTextSmall(mes?.FechaInicio)} - {getDateTextSmall(mes?.FechaFinal)})
                        </h5>}
                    </div>
                    <div style={{ height: 'calc(90vh - 130px)', }}>
                        <div style={{ height: '100%' }}>
                            <AgGrid table={{ ...tableAgentes, Data: resumenSegunAgente }} />
                        </div>

                    </div>
                    <div style={{ height: '10vh' }}>
                        <AgGrid table={{
                            ...tableAgentes, Data: ventasSegunAgente['GRAND TOTAL']?.DataAgente ?? []
                        }} />
                    </div>


                </div>

            </div>
            <div className='px-3 pt-5'>
                <div>
                    <h4>
                        {getLabel(resumenVentasLang, 'TituloVentasAnualPorAgente', config.language)} ({date.getFullYear()})
                    </h4>
                </div>
                <div style={{ height: setHeightAgGrid(tableVentasAnualPorAgente), width: '100%' }}>
                    <AgGrid table={tableVentasAnualPorAgente} />
                </div>
            </div>
            <div>
                <ResumenVentasAnualbyCliente date={date} getDatos={getInfo} />
            </div>
            <div>
                <ResumenVentasAnual date={date} />
            </div>



            <Dialog
                visible={showDialogAgent}
                onHide={() => setShowDialogAgent(false)}
                // maximizable={true} maximized={true} 
                style={{ width: '60%', height: '55%' }}
                resizable={true}
            >
                <DialogChartAgentes date={date} />
            </Dialog>

            <Dialog
                visible={showDialog}
                onHide={() => { setShowDialog(false) }}
                maximized={true}
                maximizable={true}
                closeOnEscape={false}
                style={{ width: '100%' }}
                resizable={false}
                header={<h4>{`${getLabel(baseLang, "ventasMesuales", config.language)} / ${date.getFullYear()} ($)`}</h4>}
            >
                <ResumenVentasDialog kpiGerencia={true} date={date} getDatos={getInfo} altura={true} />
            </Dialog>
        </div>
    )
}

export default DialogTablesVentasMensual